<template>
  <div class="relative flex h-full min-h-0 flex-col">
    <NoData
      v-if="geofences.length === 0"
      class="min-h-0 flex-1"
      title="There are no geofences"
      subtitle="Create the first one"
    >
      <Button icon="SquaresPlusIcon" @click="handleCreateClick">
        Create Geofence
      </Button>
    </NoData>
    <div
      v-else
      class="flex min-h-0 flex-1 flex-col"
      :class="{
        'pb-[86px] md:pb-[102px]':
          $can('manage', 'Geofences') && isBottomButton,
      }"
    >
      <div class="h-12 shrink-0 bg-gpx_gray-900" />
      <DynamicScroller
        class="min-h-0 flex-1"
        :items="props.geofences"
        :min-item-size="98"
        key-field="id"
        listClass="ds-geofence-list"
        itemClass="ds-geofence-list-item"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[
            item.name,
            item.address,
            item.place_type,
            item.ownership_type,
          ]"
            :data-index="index"
          >
            <div class="border-b border-gpx_gray-900">
              <VLink
                block
                :to="`/geofences/${item.id}`"
                class="bg-white hover:bg-gpx_gray-900"
              >
                <div class="flex py-[15px] pl-6 pr-[48px] md:pl-12 md:pr-[56px]">
                  <GeofenceListItem
                    class="w-full"
                    :geofence="item"
                    :edit-item-id="editItemId"
                    @setEditItemId="setEditItemId"
                    @resetEditItemId="resetEditItemId"
                  />
                </div>
              </VLink>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
    </div>
    <CommonBottomButtonSection
     
    v-if="$can('manage', 'Geofences') && isBottomButton"
    
  >
      <Button
        class="w-full"
        icon="SquaresPlusIcon"
        @click="router.push({ name: 'GeofenceCreateView' })"
      >
        New Geofence
      </Button>
    </CommonBottomButtonSection>
  </div>
</template>

<script setup>
import VLink from '@/components/ui/VLink.vue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import GeofenceListItem from './GeofenceListItem.vue';
import NoData from '@/components/_common/NoData.vue';
import CommonBottomButtonSection from '@/components/_common/CommonBottomButtonSection.vue';
import { useSetItemIdOnDynamicList } from '@/use/use-set-item-id-on-recycle-list';

const props = defineProps({
  geofences: Array,
});

const store = useStore();
const router = useRouter();
const isBottomButton = computed(() => store.getters['geofence/isBottomButton']);

const { editItemId, setEditItemId, resetEditItemId } =
  useSetItemIdOnDynamicList('geofence');

function handleCreateClick() {
  router.push({ name: 'GeofenceCreateView' });
}
</script>

<style>
.ds-geofence-list {
  @apply !overflow-visible;
}
</style>
